import { BrandVariants, Theme, createDarkTheme, createLightTheme } from '@fluentui/react-components';

const myNewTheme: BrandVariants = {
    10: '#020305',
    20: '#111723',
    30: '#16263D',
    40: '#FF6542',
    50: '#1B3F6A',
    60: '#1B4C82',
    70: '#FF6542EC',
    80: '#FF6542',
    90: '#3174C2',
    100: '#4F82C8',
    110: '#6790CF',
    120: '#7D9ED5',
    130: '#92ACDC',
    140: '#A6BAE2',
    150: '#BAC9E9',
    160: '#CDD8EF',
};

const fontFamilyBase = "BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif";
document.body.style.setProperty('--DefaultFontFamily', fontFamilyBase);

export const lightTheme: Theme = {
    ...createLightTheme(myNewTheme),
    fontFamilyBase,
};

export const darkTheme: Theme = {
    ...createDarkTheme(myNewTheme),
    fontFamilyBase,
};

darkTheme.colorBrandForeground1 = myNewTheme[110];
darkTheme.colorBrandForeground2 = myNewTheme[120];

darkTheme.colorNeutralBackgroundInverted = '#f1f1f1';

lightTheme.colorNeutralBackground5 = '#d9d9e3';
darkTheme.colorNeutralBackground5 = '#d9d9e3';

darkTheme.colorNeutralForegroundOnBrand= '#3D3D3D';
darkTheme.colorNeutralForeground2BrandHover= '#FF6542';

lightTheme.colorBrandBackgroundSelected= '#FF6542';
darkTheme.colorBrandBackgroundSelected= '#FF6542';